<template>
<div>
    <p>輸入港口中英文名稱、港口代碼</p>
    <p>查詢對應的資料</p>  
    <p>例如: 福澳 或是 TW</p>
    <b-input-group>
    <b-form-input size="lg"
                        type="text"
                        placeholder="查詢"
                        v-model="filter_string"></b-form-input>
    </b-input-group>
    <b-table 
        fixed 
        :sort-desc.sync="sortDesc"
        :items="items"
        :fields="portCode_fields"
        :filter="filter"
        >
    </b-table>
</div>
</template>

<script>
import portCode from '../json/portCode.json'

const items = portCode
export default {
  name: "portCode",
  data () {
    return {
      sortDesc: false,
      portCode_fields: [
        { key: '中文', sortable: true },
        { key: '英文', sortable: true },
        { key: '代碼', sortable: true }
      ],
      items: items,
      filter_string:"",
      
    }
  },
  computed: {
    filter: function(){

      
      
      if(this.filter_string == ""){
        return '""';
      }
      return this.filter_string

    }

  },
  methods: {
    info (item, index, button) {
      
    },
    resetModal () {
      
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/components/portCode.vue